import styles from './styles.module.css'
import { ACCESSIBILITY_COMPLIANCE_LINK, PRIVACY_COMPLIANCE_LINK, TERMS_OF_USE_COMPLIANCE_LINK } from '../../../global/constants/compliance-links'

export default function ComplianceLinks() {
  return (
    <p className={styles.complianceLinks} style={{ fontSize: '13.5px'}}>By proceeding you agree to our <a style={{ color: 'var(--text-primary)'}} href={TERMS_OF_USE_COMPLIANCE_LINK}>Terms of Use</a>, <a style={{ color: 'var(--text-primary)'}} href={PRIVACY_COMPLIANCE_LINK}>Privacy</a>, and <a style={{ color: 'var(--text-primary)'}} href={ACCESSIBILITY_COMPLIANCE_LINK}>Accessibility</a> policies.</p>
  )
}
